import { checkValue } from "src/components/functions";

const brandStyling = {
  expedia: {
    heading: '#141D38',
    subHeading: '#141D38', 
  },
};

const brandCss = (brand: string, bodyFont?: string) => {
  let style = brandStyling[brand];
  style = checkValue(style) ? style : brandStyling['expedia'];
  const { heading, subHeading } = style;
  const headingColor = bodyFont ? bodyFont : heading;
  const subHeadingColor = bodyFont ? bodyFont : subHeading;   
  return `
    h2{color: ${headingColor} !important;} 
    p{color: ${subHeadingColor} !important;} 
    .footer-social-txt{color: ${headingColor} !important;}
    .imgdesc{color: ${headingColor} !important;}
    .tabbed-content-content-caption-heading,
    .tabbed-content-content-caption-subheading,
    .tabbed-content-content-caption-description,
    .tabbed-content-section .uitk-tab-anchor-selected .uitk-tab-text,
    .video-section .video-testimonial.top-center .video-title,
    .video-section .video-testimonial.top-left .video-title,
    .video-section .video-testimonial.top-center .video-subtitle,
    .video-section .video-testimonial.top-left .video-subtitle
     {
        color: ${headingColor} !important;
     }
    .wizard-in .wizard-detail .wizard-tab {color: ${subHeadingColor} !important;} 
    .wizard-in .wizard-detail .wizard-form .wizard-row label {color: ${subHeadingColor} !important;} 
    .wizard-in .wizard-detail .wizard-form .uitk-typeahead .uitk-typeahead-menu .uitk-field-label {color: ${subHeadingColor} !important;}
    .wizard-in .wizard-detail .wizard-form .wizard-row .wizard-cell .uitk-form-field-trigger {color: ${subHeadingColor} !important;}
    .main-article ul li{color: ${subHeadingColor} !important;} 
  `;
};

export { brandStyling, brandCss };
